import {NavLink as RouterNavLink} from "react-router-dom";
import TableDataModel from "../Table/TableDataModel";
import TableAttributeModel from "../Table/TableAttributeModel";

export class Utilities {
    static async delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static pageSize = 20;

    static autoCompleteGroupNumber: Set<string> = new Set();
    static autoCompleteAccessCode: Set<string> = new Set();

    static tablesToShow: TableDataModel[] = [
        accessCodeTable(), videoTable(), instructorTable(), tagsTable(),
        //  remmitanceTable(),
    ]
}

export {RouterNavLink}

export declare type ApiResponseDataType = { [key: string]: string | number | boolean | undefined | string[] }
export declare type ApiResponseDataValueType = string | number | boolean | undefined | string[]

function accessCodeTable(): TableDataModel {
    const attributes: TableAttributeModel[] = [
        new TableAttributeModel({
            name: "accessCode",
            label: "Access Code",
            type: "string",
            required: true,
            primaryKey: true,
            linkedTable: undefined,
            linkedField: undefined,
            showCopy: true,
            capitalise: true
        }),
        new TableAttributeModel({
            name: "groupName",
            label: "Group Name",
            type: "string",
            required: true,
            primaryKey: false,
            linkedTable: 'videos',
            linkedField: 'groupNumber',
            showCopy: true,
            capitalise: true
        }),
    ]

    return new TableDataModel({
        name: {singular: "access-code", plural: "access-codes"},
        label: {singular: "Access Code", plural: "Access Codes"},
        apiPath: "access-codes",
        searchKey: attributes[0],
        sortKey: attributes[0],
        attributes: attributes,
        editable: true,
        deletable: true,
    })
}

function videoTable() {
    const attributes: TableAttributeModel[] = [
        new TableAttributeModel({
            name: 'batchNumber',
            label: 'Batch No.',
            type: 'string',
            required: true,
            primaryKey: true,
            autoGenerated: true,  // derived from the group name on create
        }),
        new TableAttributeModel({
            name: 'sno',
            label: 'Sno',
            type: 'number',
            required: true,
            primaryKey: true,
            autoGenerated: true,  // next sno within the batch
        }),
        new TableAttributeModel({
            name: "videoIframe",
            label: "Video Iframe",
            type: "string",
            longText: true,
            required: true,
            primaryKey: false,
            showCopy: true
        }),
        new TableAttributeModel({
            name: "groupNumber",
            label: "Group Name",
            type: "string",
            required: true,
            primaryKey: false,
            showCopy: true,
            capitalise: true,
            fieldType: 'select'
        }),
        new TableAttributeModel({
            name: "videoName",
            label: "Video Name",
            type: "string",
            required: true,
            primaryKey: false,
        }),
    ]

    return new TableDataModel({
        name: {singular: "video", plural: "videos"},
        label: {singular: "Video", plural: "Videos"},
        apiPath: "videos",
        searchKey: attributes[3],
        sortKey: attributes[1],
        attributes: attributes,
        editable: true,
        deletable: true,
    })
}

function instructorTable() {
    const attributes: TableAttributeModel[] = [
        new TableAttributeModel({
            name: 'sno',
            label: 'S. No.',
            type: 'number',
            required: true,
            primaryKey: false,
        }),
        new TableAttributeModel({
    name: 'hiredDate',
    label: 'Hired Date',
    type: 'string',   // use string type and set fieldType to 'date' to enable date picker UI
    fieldType: 'date',
    required: true,
    primaryKey: false,
    showCopy: true
}),
        new TableAttributeModel({
            name: "name",
            label: "Name",
            type: "string",
            longText: true,
            required: true,
            primaryKey: false,
            showCopy: true
        }),
        new TableAttributeModel({
            name: "email",
            label: "Email",
            type: "string",
            required: true,
            primaryKey: true,
            showCopy: true,
        }),
        new TableAttributeModel({
            name: "contact",
            label: "Contact",
            type: "string",
            required: false,
            primaryKey: false,
        }),
        new TableAttributeModel({
            name: "tags",
            label: "Tags",
            type: "string[]",
            required: true,
            primaryKey: false,
            fieldType: 'multiSelect',
        }),
        // 🔹 New field
        new TableAttributeModel({
            name: "status",
            label: "Status",
            type: "string",
            required: false,
            primaryKey: false,
        }),
    ]

return new TableDataModel({
    name: { singular: "instructor", plural: "instructor" },
    label: { singular: "Instructor", plural: "Instructor" },
    apiPath: "instructors",                     // base CRUD path
    listPath: "instructors/with-status",        // list API
    nextSnoPath: "instructors/next-sno",        //  next serial number API
    searchKey: attributes[3], // email
    sortKey: attributes[0],   // sno
    attributes: attributes,
    editable: true,
    deletable: true,
});
}

function tagsTable() {
    const attributes: TableAttributeModel[] = [
        new TableAttributeModel({
            name: "name",
            label: "Name",
            type: "string",
            longText: true,
            required: true,
            primaryKey: true,
            showCopy: true,
        }),
    ]

    return new TableDataModel({
        name: {singular: "tag", plural: "tags"},
        label: {singular: "Tag", plural: "Tags"},
        apiPath: "tags",
        searchKey: attributes[0],
        sortKey: attributes[0],
        attributes: attributes,
        editable: true,
        deletable: true,
    })
}

// function remmitanceTable() {
//     const attributes: TableAttributeModel[] = [
//         new TableAttributeModel({
//             name: "name",
//             label: "Name",
//             type: "string",
//             longText: true,
//             required: true,
//             primaryKey: false,
//             showCopy: true
//         }),
//         new TableAttributeModel({
//             name: "email",
//             label: "Email",
//             type: "string",
//             required: true,
//             primaryKey: false,
//             showCopy: true,
//             // capitalise: true,
//             // fieldType: 'select'
//         }),
//         new TableAttributeModel({
//             name: "contact",
//             label: "Contact",
//             type: "string",
//             required: false,
//             primaryKey: false,
//         }),
//         new TableAttributeModel({
//             name: "groupNumber",
//             label: "Group Number",
//             type: "string",
//             required: false,
//             primaryKey: true,
//         }),
//         new TableAttributeModel({
//             name: "netAmountPaid",
//             label: "Net Amount Paid",
//             type: "string",
//             required: false,
//             primaryKey: false,
//         }),
//         new TableAttributeModel({
//             name: "date1",
//             label: "Issue Date",
//             type: "string",
//             required: false,
//             primaryKey: false,
//         }),
//         new TableAttributeModel({
//             name: "date2",
//             label: "Trainer Invoice Date",
//             type: "string",
//             required: false,
//             primaryKey: false,
//         }),
//     ]

//     return new TableDataModel({
//         name: {singular: "remitance", plural: "remitance"},
//         label: {singular: "Remitance", plural: "Remitances"},

//         // Previous code 
//         // name: {singular: "remmitance", plural: "remmitance"},
//         // label: {singular: "Remmitance", plural: "Remmitances"},
//         apiPath: "email/remittance",
//         searchKey: attributes[3],
//         sortKey: attributes[0],
//         attributes: attributes,
//         editable: false, 
//         deletable: true,
//     })
// }
